import axios from '@/axios'

const state = {
    users: [],
    error: undefined,
    loading:false,
    loadingWithUser:false,
    loadingWithUserPeak:false,
    loadingAvgSupervisionUser:false,
    loadingChartPeak:false,
    loadingDeterminationAvg:false,
    loadingSingleUser:false,
    loadingVisionDateUser:false,
    loadingChartSingleUser:false,
    loadingChartAvgCustomer:false,
    loadingChartCountSuperVision:false,
    loadingSortUser:false,
    userEdit:[],
    userList:[],
    getDataSuccess:undefined,
    collection:{},
    deleteItem:false
};
const actions = {
    async SubmitUser({commit}, payload) {

      try {
        commit('LOADING', true);

        if(payload.id){
            await axios({
                method: 'put',
                url: 'admin/user/'+payload.id,
                data: {id:payload.id,data:payload.data,op:'update'}
            })
        }else{
            await axios({
                method: 'post',
                url: 'admin/user',
                data: {data:payload}
            })
        }

      } catch (e) {
        commit('ERROR', e);
        throw e
      } finally {
        commit('LOADING', false);
      }

    },
    async UserId({commit},id) {
        try {
            commit('LOADING', true);
            let res = await axios.get('admin/user/user/'+id);
            console.log(res.data,'res-collection')
            commit('USERS_ID', res.data);
        } catch (e) {
            commit('ERROR', e);
            throw e;
        } finally {
            commit('LOADING', false);
        }
    },
    async editUsers({commit}, payload) {
        try{
            commit('LOADING', true);
            await axios({
                method: 'put',
                url: 'admin/user/'+payload.id,
                data: {id:payload.id,data:payload.data,op:'update'}
            }).then((res)=>{
                commit('SUCCESS_DATA',res.data);
                commit('UPDATE_USERS', payload);
            })

        }catch (e) {
            commit('ERROR', e);
            throw e
        } finally {
            commit('LOADING', false);
        }

    },
    async avgWithUser({commit}, payload) {
    try {
      commit('LOADING_WITH_USER', true);
      const {data} = await axios.post('admin/user/query/avg',payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_WITH_USER', false);
    }
  },
    async peakWithUser({commit}, payload) {
    try {
      commit('LOADING_WITH_USER_PEAK', true);
      const {data} = await axios.post('admin/user/query/peak',payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_WITH_USER_PEAK', false);
    }
  },
    async avgSupervisionUser({commit}, payload) {
    try {
      commit('LOADING_AVG_SUPER_VISION_USER', true);
      const {data} = await axios.post('admin/user/query/users',payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_AVG_SUPER_VISION_USER', false);
    }
  },
    async DeterminationPeak({commit}, payload) {
    try {
      commit('LOADING_CHART_PEAK', true);
      const {data} = await axios.post('admin/user/chart/peak',payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_CHART_PEAK', false);
    }
  },
    async DeterminationAvg({commit}, payload) {
    try {
      commit('LOADING_Determination_AVG', true);
      const {data} = await axios.post('admin/user/chart/avg',payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_Determination_AVG', false);
    }
  },
    async singleUser({commit}, payload) {
    try {
      commit('LOADING_SINGLE_USER', true);
      const {data} = await axios.post('admin/user/chart/adv',payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_SINGLE_USER', false);
    }
  },
    async superVisionDateUser({commit}, payload) {
    try {
      commit('LOADING_VISION_DATE_USER', true);
      const {data} = await axios.post('admin/user/chart/count',payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_VISION_DATE_USER', false);
    }
  },
    async chartSingleUser({commit}, payload) {
    try {
      commit('LOADING_CHART_SINGLE_USER', true);
      const {data} = await axios.post('admin/user/chart/user',payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_CHART_SINGLE_USER', false);
    }
  },
    async chartCountSuperVision({commit}, payload) {
    try {
      commit('LOADING_CHART_SUPER_VISION', true);
      const {data} = await axios.post('admin/user/chart/date',payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_CHART_SUPER_VISION', false);
    }
  },
    async avgCustomers({commit}, payload) {
    try {
      commit('LOADING_CHART_AVG_CUSTOMER', true);
      const {data} = await axios.post('admin/user/chart/customer',payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_CHART_AVG_CUSTOMER', false);
    }
  },
    async SortUser({commit}, payload) {
    try {
      commit('LOADING_SORT_USER', true);
      const {data} = await axios.post('admin/user/query/collection',payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING_SORT_USER', false);
    }
  },
    async deleteUser({commit},payload) {
      try {
        commit('LOADING_DELETE', true);
        console.log(payload,'id');
        const {data} = await axios.delete('admin/user/'+ payload);
        return data;
      } catch (e) {
        throw e;
      } finally {
        commit('LOADING_DELETE', false);
      }
    }

};
const mutations = {
    INIT(state, data) {
      state.collection = data;
    },
    LOADING(state,payload){
    state.loading = payload;
  },
    LOADING_WITH_USER(state,payload){
      state.loadingWithUser = payload;
    },
    LOADING_WITH_USER_PEAK(state,payload){
      state.loadingWithUserPeak = payload;
    },
    LOADING_AVG_SUPER_VISION_USER(state,payload){
      state.loadingAvgSupervisionUser = payload;
    },
    LOADING_CHART_PEAK(state,payload){
      state.loadingChartPeak = payload;
    },
    LOADING_Determination_AVG(state,payload){
      state.loadingDeterminationAvg = payload;
    },
    LOADING_SINGLE_USER(state,payload){
      state.loadingSingleUser = payload;
    },
    LOADING_VISION_DATE_USER(state,payload){
      state.loadingVisionDateUser = payload;
    },
    LOADING_CHART_SINGLE_USER(state,payload){
      state.loadingChartSingleUser = payload;
    },
    LOADING_CHART_AVG_CUSTOMER(state,payload){
      state.loadingChartAvgCustomer = payload;
    },
    LOADING_CHART_SUPER_VISION(state,payload){
      state.loadingChartCountSuperVision = payload;
    },
    LOADING_SORT_USER(state,payload){
      state.loadingSortUser = payload;
    },
    USERS_ID(state,payload){
        state.users = payload;
    },
    SUCCESS_DATA(state, payload) {
        state.getDataSuccess = payload;
    },
    LOADING_DELETE(state, payload) {
        state.deleteItem = payload;
    },
    UPDATE_USERS(state, payload) {
        state.userEdit = state.userEdit.map(user => {
            if (user.id === payload.id) {
                return Object.assign({},user, payload.data)
            }
            return user
        })
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
